export const grayscale = [
	{
		featureType: "water",
		elementType: "geometry.fill",
		stylers: [
			{
				color: "#d3d3d3",
			},
		],
	},
	{
		featureType: "transit",
		stylers: [
			{
				saturation: -100,
			},
			{
				visibility: "off",
			},
			{
				lightness: 25,
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.stroke",
		stylers: [
			{
				visibility: "off",
			},
			{
				saturation: -100,
			},
			{
				lightness: 25,
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.fill",
		stylers: [
			{
				saturation: -100,
			},
			{
				lightness: 25,
			},
		],
	},
	{
		featureType: "road.local",
		elementType: "geometry.fill",
		stylers: [
			{
				visibility: "off",
			},
			{
				saturation: -100,
			},
			{
				weight: 1.8,
			},
		],
	},
	{
		featureType: "road.local",
		elementType: "geometry.stroke",
		stylers: [
			{
				visibility: "off",
			},
			{
				saturation: -100,
			},
		],
	},
	{
		featureType: "poi",
		elementType: "geometry.fill",
		stylers: [
			{
				visibility: "on",
			},
			{
				color: "#ebebeb",
			},
			{
				visibility: "simplified",
			},
		],
	},
	{
		featureType: "administrative",
		elementType: "geometry",
		stylers: [
			{
				saturation: -100,
			},
		],
	},
	{
		featureType: "road.arterial",
		elementType: "geometry.fill",
		stylers: [
			{
				saturation: -100,
			},
			{
				lightness: 25,
			},
		],
	},
	{
		featureType: "road.arterial",
		elementType: "geometry.fill",
		stylers: [
			{
				saturation: -100,
			},
			{
				lightness: 25,
			},
		],
	},
	{
		featureType: "landscape",
		elementType: "geometry.fill",
		stylers: [
			{
				saturation: -100,
			},
			{
				lightness: 85,
			},
			{
				visibility: "on",
			},
		],
	},
	{
		featureType: "road",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#696969",
			},
			{
				lightness: 25,
			},
		],
	},
	{
		featureType: "administrative",
		elementType: "labels.text.fill",
		stylers: [
			{
				visibility: "on",
			},
			{
				color: "#6e6e6e",
			},
		],
	},
	{
		featureType: "poi",
		elementType: "labels.icon",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "poi",
		elementType: "labels",
		stylers: [
			{
				visibility: "off",
			},
			{
				lightness: 25,
			},
		],
	},
	{
		featureType: "road.arterial",
		elementType: "geometry.stroke",
		stylers: [
			{
				saturation: -100,
			},
			{
				lightness: 25,
			},
		],
	},
	{
		featureType: "road",
		elementType: "labels.icon",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{},
	{
		featureType: "poi",
		elementType: "geometry.fill",
		stylers: [
			{
				color: "#dadada",
			},
			{
				saturation: -100,
			},
			{
				visibility: "simplified",
			},
			{
				lightness: 25,
			},
		],
	},
];
